<template>
    <div class=" headline-flex flex mb2 mt2" :class="customClass">
        <router-link :to="link">
            <svg class="back-arrow" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C18.6274 0 24 5.37256 24 12C23.9928 18.6245 18.6245 23.9927 12 24C5.37259 24 0 18.6274 0 12C0 5.37256 5.37259 0 12 0ZM5.793 12.6997L10.293 17.1997C10.6887 17.5435 11.2827 17.5234 11.6543 17.1538C12.0259 16.7842 12.0489 16.1899 11.707 15.793L9.341 13.4258C9.27002 13.354 9.24901 13.2471 9.28769 13.1538C9.32637 13.0605 9.41719 13 9.51801 13H18C18.5523 13 19 12.5522 19 12C19 11.4473 18.5523 11 18 11H9.51801C9.41586 11.001 9.32336 10.9395 9.28441 10.8452C9.24545 10.7505 9.26785 10.6421 9.341 10.5708L11.707 8.19971C11.9669 7.94873 12.0712 7.57666 11.9797 7.22705C11.8882 6.87744 11.6151 6.60449 11.2655 6.51318C10.9159 6.42139 10.5441 6.52588 10.293 6.78564L5.793 11.2856C5.40262 11.6763 5.40262 12.3091 5.793 12.6997Z"/>
            </svg>
        </router-link>
        <h1 class="black h0 ml2 headline-text">{{headline}}</h1>
    </div>
</template>
<script>
export default {
    name: "Headline",
    props: {
        'headline': String, 
        'link': String,
        'customClass': String

    }
}
</script>
<style>

</style>
